"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const log = _Logger.default.namespace('ServerSelector');
var _default = exports.default = {
  props: {
    enableCustom: {
      type: Boolean,
      default: true
    },
    showPath: {
      type: Boolean,
      default: false
    },
    usePreset: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    connection: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      presetNetworks: [],
      presetSelected: 'custom',
      serverAddress: '',
      serverPath: '',
      willEmit: false
    };
  },
  computed: {
    presetServer: {
      set(newVal) {
        this.presetSelected = newVal;
        this.$emit('selected', newVal);
        const conn = newVal === 'custom' ? Misc.getDefaultConnection() : this.presetNetworks[newVal];
        Object.assign(this.connection, conn);
      },
      get() {
        return this.presetSelected;
      }
    },
    server: {
      get() {
        return this.showPath ? this.connection.server + this.connection.path : this.connection.server;
      },
      set(value) {
        const parts = value.split('/');
        this.connection.server = parts[0];
        if (parts.length > 1) {
          this.connection.path = `/${parts.slice(1).join('/')}`;
        } else {
          this.connection.path = '';
        }
      }
    },
    serverProtocols() {
      return this.$state.getSetting('settings.serverProtocols') || ['irc', 'ircs', 'ws', 'wss'];
    },
    protocol: {
      get() {
        let proto = this.connection.direct ? 'ws' : 'irc';
        if (this.connection.tls) {
          proto += 's';
        }
        return proto;
      },
      set(newProto) {
        const proto = this.protocol;
        const portMap = {
          irc: 6667,
          ircs: 6697,
          ws: 8067,
          wss: 8097
        };
        if (portMap[proto] === this.connection.port && portMap[newProto]) {
          this.connection.port = portMap[newProto];
        }
        switch (newProto) {
          case 'irc':
            this.connection.tls = false;
            this.connection.direct = false;
            break;
          case 'ircs':
            this.connection.tls = true;
            this.connection.direct = false;
            break;
          case 'ws':
            this.connection.tls = false;
            this.connection.direct = true;
            break;
          case 'wss':
            this.connection.tls = true;
            this.connection.direct = true;
            break;
          default:
            log.error('invalid protocol');
        }
      }
    }
  },
  created() {
    const networkList = this.$state.getSetting('settings.presetNetworks') || [];
    if (networkList) {
      this.importUris(networkList);
    }

    // If the given network is in the preset server list, select it
    const con = this.connection;
    const presetIdx = this.presetNetworks.findIndex(s => {
      let match = s.server === con.server && s.port === con.port && s.tls === con.tls && s.direct === con.direct && s.path === con.path;
      return match;
    });
    if (presetIdx > -1) {
      this.presetServer = presetIdx.toString();
    } else if (!this.enableCustom && !this.connection.server && this.presetNetworks.length) {
      this.presetServer = '0';
    }
  },
  methods: {
    onServerPaste(event) {
      event.preventDefault();
      const pasted = event.clipboardData.getData('text');
      const conn = Misc.parsePresetServer(pasted);
      if (conn) {
        Object.assign(this.connection, conn);
      } else {
        this.connection.server = pasted;
      }
    },
    toggleTls() {
      if (this.disabled) {
        return;
      }
      const protocolMap = Object.fromEntries(Object.entries({
        irc: 'ircs',
        ircs: 'irc',
        ws: 'wss',
        wss: 'ws'
      }).filter(([key, value]) => this.serverProtocols.includes(key) && this.serverProtocols.includes(value)));
      if (protocolMap[this.protocol]) {
        this.protocol = protocolMap[this.protocol];
      }
    },
    importUris(serverList) {
      // [ 'freenode|irc.freenode.net:+6697', 'irc.snoonet.org:6667' ]
      const servers = [];
      serverList.forEach(server => {
        if (typeof server === 'object') {
          const conn = Misc.getDefaultConnection();
          Object.assign(conn, server);
          servers.push(conn);
          return;
        }
        const conn = Misc.parsePresetServer(server);
        if (!conn) {
          log.error('failed to parse presetNetwork:', server);
          return;
        }
        servers.push(conn);
      });
      this.$set(this, 'presetNetworks', servers);
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["ServerSelector"]
window._app_exports.components.ServerSelector = exports.default ? exports.default : exports;
